import Image from 'next/image';
import React from 'react';
import Link from 'next/link';
import { Author } from '../../../../pages/blog';

interface AuthorProfileCardProps {
  author: Author;
}

export default function AuthorProfileCard({ author }: AuthorProfileCardProps) {
  return (
    <Link
      className="2xl:w-[200px] 2xl:h-[250px] sm:w-[150px] sm:h-[183px] xl:h-[214px] flex flex-col items-center gap-3 cursor-pointer"
      href={`/author/${author.slug}`}
    >
      <Image
        src={author.image ?? '/default-profile-icon.svg'}
        alt="profile-icon"
        width={120}
        height={120}
        className="rounded-full w-[80px] h-[80px] sm:w-[110px] sm:h-[110px] xl:w-[130px] xl:h-[130px] object-cover border-[#DDDDDD] border-[2px]"
      />
      <div className="text-black2 text-sm sm:text-base 2xl:text-lg font-normal leading-[21px] text-center whitespace-nowrap">
        {author.name}
      </div>
      <div className="text-gray75 text-xs sm:text-sm xl:text-base font-normal leading-[21px] text-center">
        {author.tagLine ?? 'Travel Writer'}
      </div>
    </Link>
  );
}
